import { BlockTitle } from "@blocks/Blocks";

import GalaDinnerInvitationSection from "./GalaDinnerInvitationSection";
import GalaDinnerSection from "./GalaDinnerSection";
import MakingMoneyExercise from "./MoneyMakingExerciseSection";

/**
 * Component to render Dinner section for FAQ Page
 */
const DinnerSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="Gala Dinner"
        rootClassName="bg-gray-150 text-2xl md:text-2xl lg:text-2xl font-semibold pb-2 pt-6 pl-4"
      />

      <GalaDinnerSection />

      <GalaDinnerInvitationSection />

      <MakingMoneyExercise />
    </>
  );
};

export default DinnerSection;
